<!-- <div class="main">
    <div class="contant">
        <p>Download our Free Coaching e-Book and Begin Your Certification Now!</p>
        <button>    
            <a href="../../../assets/coaching e-book.pdf" target="_blank" class="ebook-button">
                Download Free e-Book
            </a>
        </button>

    </div>
</div> -->


<nav class="navbar navbar-expand-md navbar-light px-3" id="navbar">
  <img src="../../../assets/NEXGEN Logo final.png" alt="" class="img-fluid" routerLink="/home">

  <button class="navbar-toggler" type="button" aria-label="Toggle navigation" (click)="toggleNavbar()" >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div [class.show]="isNavbarCollapsed" class="collapse navbar-collapse" id="navbarContent">
    <ul class="navbar-nav me-auto mb-2 mb-md-0">
      <li class="nav-item">
        <a class="nav-link" routerLink="/home">Home</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/about-us">About Us</a>
      </li>

      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle"
             (click)="toggleDropdown($event)"
             [class.active]="isDropdownOpen"
             role="button">
            Certification Programs
          </a>
        <ul class="dropdown-menu" [class.show]="isDropdownOpen">
          <li><a class="dropdown-item" routerLink="/platinum-package">Platinum Packages</a></li>
          <li><a class="dropdown-item" routerLink="/gold-package">Gold Packages</a></li>
          <li><a class="dropdown-item" routerLink="/program-page">Program Packages</a></li>
          <!-- <li><a class="dropdown-item" routerLink="/business-builder">Business Builders</a></li>
          <li><a class="dropdown-item" routerLink="/leadership-certificates">Sales Leadership Certificates</a></li> -->
        </ul>
      </li>

      <li class="nav-item">
        <a class="nav-link" routerLink="/our-team">Our Team</a>
      </li>
    </ul>

    <div class="d-flex flex-wrap justify-content-end">
      <!-- <button class="btn btn-outline me-2" routerLink="/signup">Register</button> -->
      <button class="btn btn-outline signup" routerLink="/login">Sign In</button>
    </div>
  </div>
</nav>